<template>
    <div>
        <template v-if="newRow.tempFile">
            <div class="uploading-temp">
                <!-- <img :src="$utils.cdn + '/loading.png'" class="Rotation" /> -->
                <i class="el-icon-loading"></i>
                <div class="uploadgress" :id="'uploadTemp_'+newRow.id"></div>
            </div>
            <!-- https://blog.csdn.net/qq_42221334/article/details/87864020 -->
            <!-- https://blog.csdn.net/qq_41422208/article/details/85336325 -->
            <div class="uploading" style="margin-top:4px;">排队上传中...</div>
        </template>
        <template v-else>
            <template v-if="newRow.status===0">
                <div class="uploading-temp">
                    <!-- <img :src="$utils.cdn + '/loading.png'" class="Rotation" /> -->
                    <i class="el-icon-loading"></i>
                    <div class="uploadgress">100%</div>
                </div>
                <div style="line-height: 1;margin-top:4px;">上传成功</div>
            </template>
            <template v-else>
                <!-- <template v-if="row.status && (row.status.split('_')[1] === '正在转换' || row.status.split('_')[1] === '正在分类'  || 
                row.status.split('_')[1] === '等待分类'|| 
                row.status.split('_')[1] === '正在识别' || row.status.split('_')[1] === '识别完成')">
                </template> -->
                <template v-if="newRow.status && ( 
                                newRow.status.split('_')[1] === '等待转换'|| newRow.status.split('_')[1] === '正在转换' || 
                                newRow.status.split('_')[1] === '等待分类' || newRow.status.split('_')[1] === '正在分类' || 
                                newRow.status.split('_')[1] === '正在识别' ) ">
                    <div class="uploading-progress">
                        <div class="outer" :id="'uploadProgress_'+newRow.id"></div>
                    </div>
                    {{increase(newRow)}}
                    <div class="uploading">
                        {{newRow.status.split('_')[1]}}中...<em>预估等待时间{{getFormatTime(newRow.save)}}</em></div>
                </template>
                <template v-if="newRow.status && newRow.status.split('_')[1] === '解压成功'">
                    <div style="line-height: 1;">解压成功</div>
                </template>
                <template v-if="newRow.status && newRow.status.split('_')[1] === '解压失败'">
                    <div style="line-height: 1;">文件损坏，解压失败</div>
                </template>
                <template v-if="newRow.status && newRow.status.split('_')[1] === '上传成功'">
                    <div style="line-height: 1;">上传成功</div>
                </template>
                <template v-if="newRow.status && newRow.status.split('_')[1] === '上传失败'">
                    <div style="line-height: 1;">上传失败，请重新上传</div>
                </template>
                <template v-if="newRow.status && newRow.status.split('_')[1] === '分类失败'">
                    {{endTimeout(newRow)}}
                    <div style="line-height: 1.8;">单证分类失败</div>
                    <div style="line-height: 1.8;">未匹配对应的模板</div>
                </template>
                <template v-if="newRow.status && newRow.status.split('_')[1] === '分类成功'">
                    <div class="uploading-progress">
                        <div class="outer" :id="'uploadProgress_'+newRow.id"></div>
                    </div>
                    {{increase(newRow)}}
                    <div class="uploading">单证分类成功,<em>预估等待时间{{getFormatTime(newRow.save)}}</em></div>
                </template>
                <template v-if="newRow.status && newRow.status.split('_')[1] === '分类完成'">
                    <template
                        v-if="newRow.recognitionCount && newRow.recognitionCount.failed === newRow.recognitionCount.total">
                        <!-- 单证分类全部失败，结束进度条，结束计时器 -->
                        {{endTimeout(newRow)}}
                        <div style="line-height: 1;">单证分类完成</div>
                    </template>
                    <template v-else>
                        <div class="uploading-progress">
                            <div class="outer" :id="'uploadProgress_'+newRow.id"></div>
                        </div>
                        {{increase(newRow)}}
                        <div class="uploading">单证分类完成,<em>预估等待时间{{getFormatTime(newRow.save)}}</em></div>
                    </template>
                </template>
                <template v-if="newRow.status && newRow.status.split('_')[1] === '识别成功'">
                    {{endTimeout(newRow)}}
                    <div style="line-height: 1;">识别成功</div>
                    <div style="line-height: 1.8;">{{newRow.remark}}</div>
                </template>
                <template v-if="newRow.status && newRow.status.split('_')[1] === '识别失败'">
                    {{endTimeout(newRow)}}
                    <!--
                    <div style="line-height: 1.8;" v-if="newRow.recognitionCount && newRow.recognitionCount.remark === ''">识别失败</div>
                    <div style="line-height: 1.8;" v-if="newRow.recognitionCount && newRow.recognitionCount.remark === ''">未匹配对应的模板</div>
                    <div style="line-height: 1.8;" v-if="newRow.recognitionCount && newRow.recognitionCount.remark === 'AI'">AI</div>
                    -->
                    <div style="line-height: 1.8;" v-if="newRow.remark === ''">识别失败</div>
                    <div style="line-height: 1.8;" v-if="newRow.remark === ''">未匹配对应的模板</div>
                    <div style="line-height: 1.8;" v-if="newRow.remark === '未匹配对应的模板'">未匹配对应的模板</div>
                    <div style="line-height: 1.8;" v-if="newRow.remark === 'AI'">AI</div>
                    <div style="line-height: 1.8;" v-if="newRow.recognitionCount && newRow.recognitionCount.remark === 'AI'">AI</div>
                </template>
                <template v-if="newRow.status && newRow.status.split('_')[1] === '识别完成'">
                    {{endTimeout(newRow)}}
                    <div style="line-height: 1;">识别完成</div>
                    <!--<div style="line-height: 1.8;" v-if="newRow.format == 'docx'">{{newRow.remark}}</div>-->
                    <div style="line-height: 1.8;">{{newRow.remark}}</div>
                </template>
            </template>
        </template>
    </div>
</template>
<script>
    import _ from 'lodash'

    export default {
        name: 'tableSocketProcess',
        props: {
            row: Object
        },
        data() {
            return {
                newRow: {}
            };
        },
        computed: {},
        components: {},
        watch: {
            row: {
                handler: function (val, oldVal) {
                    this.newRow = _.cloneDeep(val);;
                },
                deep: true
            }
        },
        mounted() {
            this.newRow = _.cloneDeep(this.row);
        },
        methods: {
            increase(row) {
                //父类
                if (row.level === 1 || row.level >= 2) {
                    if (row.status.split('_')[1] === '等待转换') {
                        this.predict(row, 15);
                    }
                    if (row.status.split('_')[1] === '正在转换') {
                        this.predict(row, 35);
                    }
                    if (row.status.split('_')[1] === '等待分类') {
                        this.predict(row, 40);
                    }
                    if (row.status.split('_')[1] === '正在分类') {
                        this.predict(row, 50);
                    }
                    if (row.status.split('_')[1] === '分类成功') {
                        this.predict(row, 60);
                    }
                    if (row.status.split('_')[1] === '分类完成') {
                        this.predict(row, 60);
                    }
                    if (row.status.split('_')[1] === '正在识别') {
                        this.predict(row, 80);
                    }
                    if (row.status.split('_')[1] === '识别完成') {
                        this.predictFinish(row, 100);
                    }
                    if (row.status.split('_')[1] === '识别成功') {
                        this.predictFinish(row, 100);
                    }
                }
            },
            getItem(name, row) {
                let count = this.$utils.storage(name);
                if (count) {
                    progressJs("#uploadProgress_" + row.id).setOptions({ 'overlayMode': false }).set(count)
                }
            },
            predict(row, maxValue) {
                //秒，递增以1为单位
                let name = "BAILIAN-SHIBIEUPLOAD-" + row.id;

                this.getItem(name, row);
                // debugger;

                //预估时间设置
                if (row.predictCost) {
                    row.save = row.predictCost;
                    row.random = row.predictCost;
                } else {
                    if (row.random !== 0) {
                        row.save = row.random;
                    } else {
                        row.save = 200;
                    }
                }

                let second = row.save, //单位秒
                    ms = second * 1000, //单位毫秒
                    speed = 3000,
                    count = speed * 100 / ms;

                this.$nextTick(() => {

                    if (document.querySelector("#uploadProgress_" + row.id)) {
                        progressJs("#uploadProgress_" + row.id).setOptions({ 'overlayMode': false }).start().autoIncreaseStop(count, speed, maxValue).onprogress((targetElm, percent) => {
                            this.$utils.storage(name, percent);
                        });
                    }
                })
            },
            predictFinish(row, time) {
                if (document.querySelector("#uploadProgress_" + row.id)) {
                    progressJs("#uploadProgress_" + row.id).set(100).killTimer();
                }

            },
            endTimeout(row) {
                // 识别成功，清除缓存，计时器
                if (document.querySelector("#uploadProgress_" + row.id) && progressJs("#uploadProgress_" + row.id)) {
                    progressJs("#uploadProgress_" + row.id).set(100).killTimer();
                }
                let name = "BAILIAN-SHIBIEUPLOAD-" + row.id;
                localStorage.removeItem(name);
            },
            getFormatTime(time) {
                // 格式化返回时间：大于60秒显示分钟，大于60分钟显示小时
                if (time) {
                    if (time <= 60) {
                        return time + '秒';
                    } else if (time <= 60 * 60) {
                        return parseFloat(time / 60).toFixed(0) + '分钟';
                    } else {
                        let h = parseFloat(time / 60 / 60).toFixed(1).split('.');
                        return h[0] + '小时' + h[1] * 60 / 10 + '分钟';
                    }
                }
            },
        }
    };
</script>
<style>
</style>